export default __webpack_public_path__ + "static/media/expo_logo_white_kor.55d1b4e4.png";